import React, { useEffect, useState } from "react";
import "./SideMenu.css";
import logo from "../../../../assets/imgs/alsalam_logo.jpg";
import MenuItem from "./MenuItem";
import Dashboard from "../Dashboard";
import * as RiIcons from "react-icons/ri";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import Cookies from "universal-cookie";
const cookies = new Cookies();

// added more menuItems for testing
export const menuItems = [
  {
    name: cookies.get("role_id") == 0 ? "لوحة التحكم" : "الصفحة الرئيسية",
    exact: true,
    to: "/report-dashboard-mof",
    iconClassName: "bi bi-columns",
    element: <Dashboard />,
    preventID: [20, 80],
  },
  {
    name: " منصة الضرائب",
    exact: true,
    to: "",
    iconClassName: "bi bi-speedometer2",
    element: <Dashboard />,
    preventID: [1, 2, 3, 4, 5],
    subMenus: [
      {
        name: "مجاميع المهن",
        exact: true,
        to: `/GroupsOfCarriers`,
        iconClassName: "bi bi-collection-fill",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "أضافة أصناف",
        exact: true,
        to: `/AddVarieties`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "أضافة أقسام",
        exact: true,
        to: `/AddSections`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "أضافة نشاط",
        exact: true,
        to: `/AddActivityType`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "أضافة فرع",
        exact: true,
        to: `/add_branch`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "أضافة مسمى وظيفي",
        exact: true,
        to: `/add_role`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "اضافة الصلاحيات",
        exact: true,
        to: `/add_permission`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "اضافة المراحل",
        exact: true,
        to: `/add_stage`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "اضافة نوع معاملة",
        exact: true,
        to: `/add_transaction_type`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "اضافة حالات قبول",
        exact: true,
        to: `/add_approval_status`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
      {
        name: "المستخدمين ",
        exact: true,
        to: `/add_user`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2, 3, 4, 5],
      },
    ],
  },
  {
    name: "تقرير ضريبة الدخل",
    to: "",
    iconClassName: "bi bi-book-half",
    element: <Dashboard />,
    preventID: [20, 80],

    subMenus: [
      {
        name: "تقارير ضريبةالدخل",
        exact: true,
        to: `/income_tax_report`,
        iconClassName: "bi bi-collection-fill",
        preventID: [20, 80],
      },
      {
        name: "اضافة تقرير",
        exact: true,
        to: `/insert_income_tax_report`,
        iconClassName: "bi bi-plus-square",
        preventID: [1, 2],
      },
    ],
  },
];

export default function SideMenu(props) {
  const [inactive, setInactive] = useState(false);

  const removeCookie = () => {
    cookies.remove("token");
    cookies.remove("role_id");
    cookies.remove("userName");

    window.location.href = "/mof-login";
  };

  useEffect(() => {
    if (inactive) {
      removeActiveClassFromSubMenu();
    }
  }, [inactive]);

  useEffect(() => {
    setInactive(props.inactive != null ? props.inactive : false);
  }, [props.inactive]);

  //just an improvment and it is not recorded in video :(
  const removeActiveClassFromSubMenu = () => {
    document.querySelectorAll(".sub-menu").forEach((el) => {
      el.classList.remove("active");
    });
  };

  /*just a little improvement over click function of menuItem
    Now no need to use expand state variable in MenuItem component
  */
  useEffect(() => {
    let menuItems = document.querySelectorAll(".menu-item");
    menuItems.forEach((el) => {
      el.addEventListener("click", (e) => {
        const next = el.nextElementSibling;
        removeActiveClassFromSubMenu();
        menuItems.forEach((el) => el.classList.remove("active"));
        el.classList.toggle("active");
        console.log(next);
        if (next !== null) {
          next.classList.toggle("active");
        }
      });
    });
  }, []);
  return (
    <div className={`side-menu ${inactive ? "inactive" : ""}`}>
      <div className="top-section">
        <div className="d-flex align-items-center">
          <div className="logo ">
            <RiIcons.RiBankFill
              size={!inactive ? 50 : 40}
              color="rgb(46,82,102)"
              className="cursor-pointer"
              onClick={() => {
                setInactive(!inactive);
                props.setInactiveFromProps(!inactive);
              }}
            />
          </div>
          {!inactive ? (
            <span className="topNamePa">
              وزارة المالية
              <br />
              الهيئة العامة للضرائب
            </span>
          ) : null}
        </div>
        <div
          onClick={() => {
            setInactive(!inactive);
            props.setInactiveFromProps(!inactive);
          }}
          className="toggle-menu-btn"
        >
          {inactive ? (
            <i className="bi bi-arrow-left-square-fill arrowIcon d-none"></i>
          ) : (
            <i className="bi bi-arrow-right-square-fill arrowIcon"></i>
          )}
        </div>
      </div>

      <div
        className="search-controller"
        onClick={() => {
          setInactive(!inactive);
          props.setInactiveFromProps(!inactive);
        }}
      >
        <button className="search-btn">
          <i className="bi bi-search"></i>
        </button>

        <input type="text" placeholder="أبحث..." />
      </div>

      <div className="divider"></div>

      <div className="main-menu">
        <ul>
          {menuItems.map((menuItem, index) => (
            <MenuItem
              key={index}
              name={menuItem.name}
              exact={menuItem.exact}
              to={menuItem.to}
              subMenus={menuItem.subMenus}
              preventID={menuItem.preventID}
              iconClassName={menuItem.iconClassName}
              onClick={(e) => {
                if (inactive) {
                  setInactive(false);
                  props.setInactiveFromProps(!inactive);
                }
              }}
            />
          ))}
        </ul>
      </div>

      <div className="logout py-3" onClick={removeCookie}>
        <LogoutSharpIcon
          style={{ fill: "#5F7B8A", fontSize: 35, marginRight: "7px" }}
        />
        <h6 className="footerText">تسجيل الخروج</h6>
      </div>

      <div className="side-menu-footer">
        <div className="avatar">
          <img src={logo} alt="user" />
        </div>
        <div className="user-info">
          <h6 className="footerText">منصة الضرائب </h6>
          <p>contact@alsalam.gov.iq</p>
        </div>
      </div>
    </div>
  );
}
